import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import ModalOverlay from "#src/components/ModalOverlay.vue";
import { ref, Ref, computed } from 'vue';
import { useVolumesStore, useLayersStore } from '#src/store.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'VolumesOverlay',
  emits: {
  hide: null,
},
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const volumeStore = useVolumesStore();
const layerStore = useLayersStore();

const { activeLayers, selectLayers } = layerStore;

const emit = __emit;


const activeVolumes = computed(() => {
  const res: Set<string> = new Set();
  for (const volume of volumes) {
    for (const image_layer of volume.image_layers) {
      for (const layer of activeLayers) {
        if (image_layer.source[0] === layer) {
          res.add(volume.name);
        }
      }
    }
    for (const segmentation_layer of volume.segmentation_layers) {
      for (const layer of activeLayers) {
        if (segmentation_layer.source[0] === layer) {
          res.add(volume.name);
        }
      }
    }
  }
  return res;
});

storeToRefs;

const volumes = volumeStore.volumes;

const selectedVolumeName: Ref<string | undefined> = ref(undefined);
const selectedImageSource: Ref<string | undefined> = ref(undefined);
const selectedSegmentationSource: Ref<string | undefined> = ref(undefined);
const selectedVolume = computed(() => {
  for (const volume of volumes) {
    if (volume.name === selectedVolumeName.value) {
      return volume;
    }
  }
  return undefined;
});
const selectedImageLayer = computed(() => {
  const volume = selectedVolume.value;
  if (volume) {
    for (const layer of volume.image_layers) {
      if (layer.source[0] === selectedImageSource.value) {
        return layer;
      }
    }
  }
  return undefined;
});
const selectedSegmentationLayer = computed(() => {
  const volume = selectedVolume.value;
  if (volume) {
    for (const layer of volume.segmentation_layers) {
      if (layer.source[0] === selectedSegmentationSource.value) {
        return layer;
      }
    }
  }
  return undefined;
});
function selectVolume(name: string) {
  selectedVolumeName.value = name;
  const volume = selectedVolume.value;
  let defaultSelectedImage: string | undefined = undefined;
  let defaultSelectedSegmentation: string | undefined = undefined;
  if (volume) {
    for (const layer of volume.image_layers.slice().reverse()) {
      defaultSelectedImage = layer.source[0];
      if (activeLayers.has(layer.source[0])) {
        break;
      }
    }
    for (const layer of volume.segmentation_layers.slice().reverse()) {
      defaultSelectedSegmentation = layer.source[0];
      if (activeLayers.has(layer.source[0])) {
        break;
      }
    }
  }
  selectedImageSource.value = defaultSelectedImage;
  selectedSegmentationSource.value = defaultSelectedSegmentation;
}
const canConfirm = computed(() => {
  return selectedSegmentationLayer.value !== undefined
    && selectedImageLayer.value !== undefined
    && (!(activeLayers.has(selectedImageLayer.value.source[0]))
      || !(activeLayers.has(selectedSegmentationLayer.value.source[0])));
});
function confirmSelection() {
  if (canConfirm.value) {
    const layers = [selectedImageLayer.value, selectedSegmentationLayer.value].map(x => {
      const { source, ngl_image_name, name, type } = x!;

      let sourceAsArray = Array.isArray(source) ? source : [source];
      return {
        name: ngl_image_name || name,
        source: sourceAsArray,
        type,
        tab: 'source'
      }
    });
    selectLayers(layers);
    emit('hide');
  }
}

const __returned__ = { volumeStore, layerStore, activeLayers, selectLayers, emit, activeVolumes, volumes, selectedVolumeName, selectedImageSource, selectedSegmentationSource, selectedVolume, selectedImageLayer, selectedSegmentationLayer, selectVolume, canConfirm, confirmSelection, ModalOverlay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})